import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { client } from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      // Msg 73 follow-up: /auth/me can legitimately return 401 for signed-out
      // visitors — that's not an error, it's the anonymous state. validateStatus
      // treats 401 as successful so axios doesn't reject and the browser doesn't
      // log a red network line on every public page.
      const r = await client.get("/auth/me", { validateStatus: (s) => s === 200 || s === 401 });
      setUser(r.status === 200 ? r.data : null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, skip the /me check — AuthCallback handles session exchange first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await client.post("/auth/logout");
    } catch {}
    setUser(null);
    window.location.href = "/";
  }, []);

  return <AuthContext.Provider value={{ user, loading, refresh, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
